export default __webpack_public_path__ + "static/media/427852_a.27630bcb.png";